import React from 'react';
import { useSelector } from 'react-redux';
import { SAlert, SRow, SCol } from '@avalara/skylab-sdk/react';
import styled from 'styled-components';
import { purchaseDeflectionWording } from '../../helpers';
import { selectState } from '../../../selectors';
const PaymentTextWrapper = styled.div `
  font-size: 16px;
  > s-alert {
    position: relative;
    margin-bottom: 20px;
  }
`;
const PaymentText = () => {
    const { account: { isAdmin, isLoggedIn } } = useSelector(selectState);
    return (React.createElement(PaymentTextWrapper, null, (isLoggedIn && isAdmin === false)
        ? React.createElement(SAlert, { status: 'warning', noDismiss: true },
            React.createElement("div", null, purchaseDeflectionWording))
        : React.createElement(SRow, null,
            React.createElement(SCol, { span: '9' },
                React.createElement("p", null, "Your payment method will be used for automatic payment of all invoices."),
                React.createElement("br", null),
                React.createElement("p", { className: 'font-semibold' }, "Keep in mind:"),
                React.createElement("p", null,
                    "You're authorizing us to process payment using your payment method. ",
                    'We will automatically charge your payment method on the invoice due date. ',
                    'You can update your payment method at any time')))));
};
export default PaymentText;
